import { NgModule, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { EventTypes, PublicEventsService } from 'angular-auth-oidc-client';
import { filter } from 'rxjs';

import { checkLoginStateFromServiceEvent } from '../../state/actions/core.actions';

@NgModule({})
export class OauthModule {
    private eventService = inject(PublicEventsService);
    private store = inject(Store);

    constructor() {
        this.eventService
            .registerForEvents()
            .pipe(
                filter(
                    notification =>
                        notification.type === EventTypes.CheckingAuthFinished ||
                        notification.type === EventTypes.CheckingAuthFinishedWithError,
                ),
            )
            .subscribe(event => this.store.dispatch(checkLoginStateFromServiceEvent({ event })));
    }
}
